import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import { textType, useTextStyles } from "../resources/AppTexts";
import PropTypes from "prop-types";

const TextMonitoring = ({ style, type, text, color, marginLeft, margin }) => {
  const [styles, setStyles] = useState();
  const texts = useTextStyles();
  if (style == null) {
    style = "inherit";
  }

  useEffect(() => {
    switch (type) {
      case textType.NUMBER:
        setStyles(texts.number);
        break;
      case textType.TITLE:
        setStyles(texts.title);
        break;
      case textType.TITLE_MEDIUM:
        setStyles(texts.title_medium);
        break;
      case textType.TITLE_BOLD:
        setStyles(texts.title_bold);
        break;
      case textType.SUBTITLE:
        setStyles(texts.subtitle);
        break;
      case textType.SUBTITLE_MEDIUM:
        setStyles(texts.subtitle_medium);
        break;
      case textType.SUBTITLE_BOLD:
        setStyles(texts.subtitle_bold);
        break;
      case textType.BODY:
        setStyles(texts.body);
        break;
      case textType.BODY_MEDIUM:
        setStyles(texts.body_medium);
        break;
      case textType.BODY_BOLD:
        setStyles(texts.body_bold);
        break;
      case textType.BODY_CARD:
        setStyles(texts.body_card);
        break;
      case textType.BODY_DRAWER:
        setStyles(texts.body_drawer);
        break;
      case textType.BODY_BREADCRUMBS:
        setStyles(texts.body_breadcrumbs);
        break;
      case textType.BODY_SUBTEXT:
        setStyles(texts.body_subtext);
        break;
      default:
        break;
    }
  }, []);

  return (
    <Box
      style={{
        color: color,
        marginTop: margin,
        marginBottom: margin,
        marginLeft: marginLeft,
      }}
    >
      <p style={{ overflowWrap: style }} className={styles}>
        {text}
      </p>
    </Box>
  );
};

TextMonitoring.propTypes = {
  type: PropTypes.string.isRequired,
  // text: PropTypes.string.isRequired,
  color: PropTypes.string,
};

export default TextMonitoring;
